import { render, staticRenderFns } from "./IconSvgArrowUp.vue?vue&type=template&id=b671f30e&scoped=true&"
import script from "./IconSvgArrowUp.vue?vue&type=script&lang=js&"
export * from "./IconSvgArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b671f30e",
  null
  
)

export default component.exports